import { render } from "./TheUploadPage.vue?vue&type=template&id=2c2b08b2&scoped=true&ts=true"
import script from "./TheUploadPage.vue?vue&type=script&lang=ts"
export * from "./TheUploadPage.vue?vue&type=script&lang=ts"

import "./TheUploadPage.vue?vue&type=style&index=0&id=2c2b08b2&lang=css&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2b08b2"]])

export default __exports__